import { render, staticRenderFns } from "./WechatConnect.vue?vue&type=template&id=f6694026&"
import script from "./WechatConnect.vue?vue&type=script&lang=js&"
export * from "./WechatConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports